import React from 'react';
import classNames from 'classnames';

const ReportingStat = ({ value = '–', label, href }) => {
  const LabelComponent = href ? 'a' : 'span';
  const labelClassName = classNames('ReportingStat-label', {
    'ReportingStat-label--linked': !!href,
  });
  return (
    <div className="ReportingStat">
      <div className="ReportingStat-value">{value}</div>
      <LabelComponent href={href} className={labelClassName}>
        {label}
      </LabelComponent>
    </div>
  );
};

export default ReportingStat;
